import {useDispatch} from "react-redux";

import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import {getFotografiaPlanta, getTempoEtapas} from "../../../actions/orderActions";
import EtapaCardList from "./EtapaCardList";
import {changeFilter} from "../../../actions/FilterActions";
import {getEstacoesTrabalho, getLoginLogoutsHoje, getProcessos} from "../../../actions/i4Actions";
import OperadoresNaLinhaGrid from "../../../common/OperadoresNaLinhaGrid";


const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap'

    },

    operadores: {
        alignContent: 'flex-start'
    }
}));

const today = new Date();


const PainelTV1 = ( props ) => {
    const classes = useStyles();
    const { setTitulo } = props;

    const [show, setShow] = useState(false);


    const dispatch = useDispatch();




    useEffect( () => {
        //console.log("dispatch getFotografia")
        //console.log("hoje", today,  today.toISOString(), today.toDateString(), today.toUTCString())


        dispatch(changeFilter({ "periodMin": today.toISOString().substring(0, 8)+today.getDate().toString().padStart(2,'0')+'T00:00:00' }));
        dispatch(changeFilter({ "periodMax": today.toISOString().substring(0, 8)+today.getDate().toString().padStart(2,'0')+'T23:59:59' }));
        dispatch(getFotografiaPlanta());
        dispatch(getTempoEtapas())
        dispatch(getEstacoesTrabalho());
        dispatch(getProcessos());
        dispatch(getLoginLogoutsHoje());

        props.setTitulo("PERFORMANCE POR ETAPA - HOJE");

    }, [props.contador]);


    return (
        <React.Fragment>
            <Grid container className={classes.mainGrid}>
                <Grid item container xs={12} sm={12} lg={12} xl={12}>

                    <Grid item container xs={9} sm={9} lg={10} xl={10}>
                        <EtapaCardList/>
                    </Grid>
                    <Grid item container className={classes.operadores} xs={3} sm={3} lg={2} xl={2}>
                        <OperadoresNaLinhaGrid/>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    )

}
export default (PainelTV1);


